import { queryInfoCheckDetail } from "@/api/register";
export const mixinCommon = {
  data() {
    return {
      // 面包屑相关数据
      // name: "",
      mainTypeName: "",
      // 审批状态icon的样式
      approving: "",
      approvingStatus: true,
      approvingType: {
        2: "approving", // 审批中
        3: "approvaled", // 审批通过
        4: "sendback", // 已退回
        5: "unapproval", // 审批不通过
        6: "withdrawn" // 已撤回
      },
      // 阅读记录数据
      tableDataRead: [],
      // 审批记录数据
      activities: [],
      // 编辑
      dialogEdit: false,
      // 同意,不同意
      dialogAgree: false,
      dialogAgreeType: "",
      dialogAgreeValue: "",
      // 退回
      dialogReturn: false,
      dialogReturnValue: "",
      dialogReturnTags: [],
      dialogReturnPerson: [],
      // 转审,协办
      dialogTransfer: false,
      dialogTransferType: "transfer",
      dialogTransferValue: "",
      dialogTransferTags: [],
      dialogTransferReset: true,
      tagCon: "", // 知会拼接多个name
      dialogTransferDefaultProps: {
        label: "name",
        isLeaf: "isLeaf"
      },
      // 底部功能按钮相关
      approvalButtons: [
        {
          type: "btnEdit",
          text: "编辑",
          icon: "icon-ccui-edit",
          click: () => {
            this.dialogEdit = true;
          }
        },
        {
          type: "btnAgree",
          text: "同意",
          icon: "icon-ccui-agree",
          click: () => {
            this.dialogAgreeClick("agree");
          }
        },
        {
          type: "btnDisAgree",
          text: "不同意",
          icon: "icon-ccui-disagree",
          click: () => {
            this.dialogAgreeClick("disAgree");
          }
        },
        {
          type: "btnBack",
          text: "退回",
          icon: "icon-ccui-reject",
          click: () => {
            this.dialogReturnClick();
          }
        },
        {
          type: "btnTransfer",
          text: "转审",
          icon: "icon-ccui-transfer",
          click: () => {
            this.dialogTransferClick("transfer");
          }
        },
        {
          type: "btnAssist",
          text: "协办",
          icon: "icon-ccui-jointly",
          click: () => {
            this.dialogTransferClick("assist");
          }
        },
        {
          type: "btnTell",
          text: "知会",
          icon: "icon-ccui-notify",
          click: () => {
            this.dialogTransferClick("notify");
          }
        }
      ],
      approvalButtonAuth: {}
    };
  },
  computed: {
    // 获取地址栏面包屑数据
    breadcrumbObj() {
      return JSON.parse(this.$route.query.breadcrumb);
    },
    // 获取业务数据所需入参
    businessParams() {
      return Object.keys(this.$store.getters.businessList).length > 0
        ? this.$store.getters.businessList
        : JSON.parse(localStorage.getItem("businessList"));
    },
    isShowDivider() {
      let newApprovalButtonAuth = JSON.parse(
        JSON.stringify(this.approvalButtonAuth)
      );
      delete newApprovalButtonAuth.bizState;
      let isShow = Object.values(newApprovalButtonAuth).every(item => {
        return item === "0";
      });
      return isShow;
    }
  },
  created() {
    this.getList();
    this.getApprovalRecord();
    this.getReadRecord();
    this.getApprovalButton();
  },
  mounted() {
    // 顶部导航进入模板无法active
    let navDom = document.querySelectorAll(".el-top-nav-menu3 .nav a");
    for (let dom of navDom) {
      if (dom.hash.slice(1) === this.breadcrumbObj.path) {
        dom.classList.add("router-link-active");
      }
    }
  },
  methods: {
    // 审批记录
    getApprovalRecord() {
      const obj = {
        businessBillId: this.businessParams.businessBillId,
        businessCode: this.businessParams.businessCode,
        businessBillType: this.businessParams.businessBillType,
        currentOperUserId:
          this.breadcrumbObj.type === "todo"
            ? this.businessParams.handleUserId
            : this.businessParams.readUserId
      };
      getApprovalRecord(obj).then(res => {
        res.data.data.forEach(item => {
          if (item.status === 0) {
            item.icon = "el-icon-time";
            item.color = "#F5A623";
          }
        });
        this.activities = res.data.data;
      });
    },
    // 阅读记录
    getReadRecord() {
      const obj = {
        businessBillId: this.businessParams.businessBillId,
        businessCode: this.businessParams.businessCode,
        businessBillType: this.businessParams.businessBillType,
        currentOperUserId:
          this.breadcrumbObj.type === "todo"
            ? this.businessParams.handleUserId
            : this.businessParams.readUserId
      };
      getReadRecord(obj).then(res => {
        this.tableDataRead = res.data.data;
      });
    },
    downLoadFile(uploadId) {
      window.open(
        `${location.origin}/apis/asca/file/download?uploadId=${uploadId}&agentId=${this.businessParams.agentId}`
      );
    },
    // 查询审批按钮
    getApprovalButton() {
      console.log(
        JSON.parse(this.$route.query.breadcrumb),
        "JSON.parse(this.$route.query.breadcrumb)"
      );
      if (
        JSON.parse(this.$route.query.breadcrumb).name === "我的已阅" ||
        JSON.parse(this.$route.query.breadcrumb).name === "我的待阅"
      ) {
        return;
      } else {
        const obj = {
          procInstId: this.businessParams.procInstId,
          workItemId: this.businessParams.taskId,
          businessBillId: this.businessParams.businessBillId,
          businessCode: this.businessParams.businessCode,
          businessBillTypeCode: this.businessParams.businessBillType,
          todoId: this.businessParams.id,
          currentOperUserId:
            this.breadcrumbObj.type === "todo"
              ? this.businessParams.handleUserId
              : this.businessParams.readUserId,
          currentOperUserDeptId:
            this.breadcrumbObj.type === "todo"
              ? this.businessParams.handleUserDeptId
              : this.businessParams.readUserDeptId
        };
        getApprovalButton(obj).then(res => {
          this.approvalButtonAuth = res.data.data || {};
          //   this.approvalButtonAuth = {
          //     btnDisAgree: "1",
          //     btnBack: "1",
          //     btnEdit: "1",
          //     bizState: 1,
          //     btnTell: "1",
          //     btnAssist: "1",
          //     btnTransfer: "1",
          //     btnAgree: "1"
          //   };
        });
      }
    },
    // 返回
    handleBack() {
      this.$router.push(this.breadcrumbObj.path);
    },
    // 同意,不同意底部按钮点击
    dialogAgreeClick(type) {
      this.dialogAgreeValue = "";
      this.dialogAgree = true;
      this.dialogAgreeType = type;
    },
    // 转审,协办底部按钮点击
    dialogTransferClick(type) {
      console.log(type, "转审协办typeconsole");
      this.dialogTransfer = true;
      this.dialogTransferType = type;
    },
    // 转审,协办人员加载
    dialogTransferLoadNode(node, resolve) {
      if (node) {
        let obj = {
          transfer: 6,
          assist: 5,
          notify: 7
        };
        if (node.level === 0) {
          getPartyRelationTree({
            thisPartyId: null,
            currentOperUserId:
              this.breadcrumbObj.type === "todo"
                ? this.businessParams.handleUserId
                : this.businessParams.readUserId,
            currentOperUserDeptId:
              this.breadcrumbObj.type === "todo"
                ? this.businessParams.handleUserDeptId
                : this.businessParams.readUserDeptId,
            agentId: this.businessParams.agentId,
            queryTypeCode: obj[this.dialogTransferType],
            isShowLoading: true
          })
            .then(res => {
              return resolve(res.data.data);
            })
            .catch(e => {
              resolve([]);
            });
        }
        if (node.level > 0) {
          getPartyRelationTree({
            thisPartyId: node.data.partyId,
            currentOperUserId:
              this.breadcrumbObj.type === "todo"
                ? this.businessParams.handleUserId
                : this.businessParams.readUserId,
            currentOperUserDeptId:
              this.breadcrumbObj.type === "todo"
                ? this.businessParams.handleUserDeptId
                : this.businessParams.readUserDeptId,
            agentId: this.businessParams.agentId,
            queryTypeCode: obj[this.dialogTransferType],
            isShowLoading: true
          })
            .then(res => {
              resolve(res.data.data);
            })
            .catch(e => {
              resolve([]);
            });
        }
      }
    },
    // 转审,协办人员点击
    dialogTransferNodeClick(item) {
      if (this.dialogTransferType == "notify") {
        !this.dialogTransferTags.find(value => {
          return item.id === value.id;
        }) && this.dialogTransferTags.push(item);
        if (this.dialogTransferTags.length) {
          this.tagCon = "";
          this.dialogTransferTags.forEach(item => {
            this.tagCon += item.name + " ";
          });
        }
      } else {
        !this.dialogTransferTags.find(value => {
          return item.id === value.id;
        }) &&
          item.userId &&
          this.dialogTransferTags.length < 1 &&
          this.dialogTransferTags.push(item);
      }
    },
    // 转审,协办删除人员
    dialogTransferTagsClose(tag) {
      this.dialogTransferTags.splice(this.dialogTransferTags.indexOf(tag), 1);
    },
    // 转审,协办清空数据
    dialogTransferClose() {
      this.dialogTransferTags = [];
      this.dialogTransferValue = "";
      this.dialogTransferReset = false;
      this.$nextTick(() => {
        this.dialogTransferReset = true;
      });
    },
    // 退回底部按钮点击
    dialogReturnClick() {
      this.dialogReturn = true;
      const obj = {
        procInstId: this.businessParams.procInstId,
        actInstId: this.businessParams.actInstId,
        taskId: this.businessParams.taskId,
        businessBillId: this.businessParams.businessBillId,
        businessCode: this.businessParams.businessCode,
        businessBillType: this.businessParams.businessBillType,
        orgId: this.businessParams.orgId,
        appId: this.businessParams.appId,
        agentId: this.businessParams.agentId,
        isShowLoading: true,
        currentOperUserId:
          this.breadcrumbObj.type === "todo"
            ? this.businessParams.handleUserId
            : this.businessParams.readUserId,
        currentOperUserDeptId:
          this.breadcrumbObj.type === "todo"
            ? this.businessParams.handleUserDeptId
            : this.businessParams.readUserDeptId
      };
      // 延迟请求,loading不出现问题
      this.$nextTick(() => {
        getReturnPerson(obj).then(res => {
          this.dialogReturnPerson = res.data.data;
        });
      });
    },
    // 退回人员点击
    dialogReturnPersonClick(item) {
      !this.dialogReturnTags.find(value => {
        return item.id === value.id;
      }) &&
        this.dialogReturnTags.length < 1 &&
        this.dialogReturnTags.push(item);
    },
    // 退回人员删除
    dialogReturnTagsClose(tag) {
      this.dialogReturnTags.splice(this.dialogReturnTags.indexOf(tag), 1);
    },
    // 所有dialog确定按钮点击
    dialogAgreeSubmit(type, verify) {
      let isVerify = false;
      verify &&
        verify.forEach(item => {
          if (Object.prototype.toString.call(this[item]) === "[object Array]") {
            if (this[item].length === 0) {
              this.messageInfo("error", "人员不能为空");
              isVerify = true;
            }
          } else {
            if (this[item].length > 500) {
              this.messageInfo("error", "您输入超过500字，请重新输入");
              isVerify = true;
            }
          }
        });
      if (isVerify) {
        return;
      }

      if (type !== "notify") {
        this.getApprovalExecute(type);
      } else {
        this.notifyFn(type);
      }
    },
    // 同意,不同意,退回,转审,协办 接口调用
    getApprovalExecute(type) {
      const typeObj = {
        // 同意
        agree: {
          operCode: 2,
          opinion: "dialogAgreeValue",
          dialogType: "dialogAgree"
        },
        // 不同意
        disAgree: {
          operCode: 4,
          opinion: "dialogAgreeValue",
          dialogType: "dialogAgree"
        },
        // 退回
        returnPerson: {
          operCode: 3,
          opinion: "dialogReturnValue",
          participantList: "dialogReturnTags",
          dialogType: "dialogReturn",
          isApplyUser:
            this.dialogReturnTags.length > 0 &&
            (this.dialogReturnTags[0].activityDefID === "startActivity"
              ? 1
              : 0),
          participantListId: "id"
        },
        // 转审
        transfer: {
          operCode: 6,
          opinion: "dialogTransferValue",
          participantList: "dialogTransferTags",
          dialogType: "dialogTransfer",
          participantListId: "userId",
          participantListDeptId: "deptId"
          //  queryTypeCode: 5
        },
        // 协办
        assist: {
          operCode: 5,
          opinion: "dialogTransferValue",
          participantList: "dialogTransferTags",
          dialogType: "dialogTransfer",
          //  bizState: 3,
          participantListId: "userId",
          participantListDeptId: "deptId"
          //  queryTypeCode: 6
        }
      };
      const obj = {
        bizState: this.approvalButtonAuth.bizState,
        procInstId: this.businessParams.procInstId,
        actInstId: this.businessParams.actInstId,
        actInstName: this.businessParams.actInstName,
        taskId: this.businessParams.taskId,
        taskName: this.businessParams.taskName,
        opinion: this[typeObj[type].opinion],
        operCode: typeObj[type].operCode,
        businessBillId: this.businessParams.businessBillId,
        businessCode: this.businessParams.businessCode,
        businessBillType: this.businessParams.businessBillType,
        orgId: this.businessParams.orgId,
        agentId: this.businessParams.agentId,
        //   bizState: typeObj[type].bizState || 0,
        isApplyUser: typeObj[type].isApplyUser ? typeObj[type].isApplyUser : 0,
        currentOperUserId:
          this.breadcrumbObj.type === "todo"
            ? this.businessParams.handleUserId
            : this.businessParams.readUserId,
        currentOperUserDeptId:
          this.breadcrumbObj.type === "todo"
            ? this.businessParams.handleUserDeptId
            : this.businessParams.readUserDeptId,
        participantList: typeObj[type].participantList
          ? this[typeObj[type].participantList].map(item => {
              return {
                id:
                  type === "returnPerson"
                    ? item[typeObj[type].participantListId]
                    : item[typeObj[type].participantListId] +
                      "#" +
                      item[typeObj[type].participantListDeptId],
                name: item.name,
                typeCode: item.typeCode || "emp",
                workItemID: item.workItemID || "",
                activityDefID: item.activityDefID || "",
                activityInstID: item.activityInstID || ""
              };
            })
          : []
        //   queryTypeCode: typeObj[type].queryTypeCode
      };
      getApprovalExecute(obj).then(res => {
        if (res.data.code == "0") {
          this.messageInfo("success", res.data.message, () => {
            this.$router.push(this.breadcrumbObj.path);
          });
        } else {
          this.messageInfo("error", res.data.message);
        }
        this[typeObj[type].dialogType] = false;
      });
    },
    // 知会接口调用
    notifyFn(type) {
      let params = this.dialogTransferTags.map(item => {
        let {
          title,
          applyTime,
          applyUserId,
          applyUserName,
          applyDeptId,
          applyDeptName,
          applyUnitId,
          applyUnitName,
          procInstId,
          actInstId,
          actInstName,
          taskId,
          participantType,
          businessBillId,
          businessCode,
          businessBillType,
          appId,
          agentId,
          createUserId,
          createTime,
          createAgentId,
          isDelete
        } = this.businessParams;
        let { orgId } = item;
        return {
          title,
          applyTime,
          applyUserId,
          applyUserName,
          applyDeptId,
          applyDeptName,
          applyUnitId,
          applyUnitName,
          procInstId,
          actInstId,
          actInstName,
          taskId,
          participantType,
          businessBillId,
          businessCode,
          businessBillType,
          status: 0,
          orgId,
          appId,
          agentId,
          createUserId,
          createTime,
          createAgentId,
          isDelete,
          readUserId: item.userId,
          bizState: this.approvalButtonAuth.bizState,
          readUserDeptId: item.deptId
          //  queryTypeCode: 7
        };
      });

      getReadMsgBatchAdd({
        readMsgList: params
      }).then(res => {
        if (res.data.code == "0") {
          this.messageInfo("success", res.data.message);
          this.$router.push(this.breadcrumbObj.path);
        } else {
          this.messageInfo("error", res.data.message);
        }
        this.dialogTransfer = false;
      });
    },
    handleExport() {
      window.open(
        `${location.origin}/apis/asca/excel/exportExcel?businessBillId=${this.businessParams.businessBillId}&businessCode=${this.businessParams.businessCode}&businessBillType=${this.businessParams.businessBillType}&requestUrl=${this.businessParams.interfaceUrl}&requestAppId=${this.businessParams.requestAppId}&agentId=${this.businessParams.agentId}`
      );
    },
    handlePrint() {
      this.$nextTick(() => {
        this.$refs.noPrintTop.innerHTML = "";
        this.$refs.noPrintBottom.innerHTML = "";
        window.print();
        location.reload();
      });
    },
    //  更新我的待阅中已阅按钮
    getUpdataRead() {
      console.log(1111111111 + "adadadas");
      let obj = {
        id: this.businessParams.id,
        businessBillId: this.businessParams.businessBillId,
        businessCode: this.businessParams.businessCode,
        businessBillType: this.businessParams.businessBillType,
        procInstId: this.businessParams.procInstId,
        actInstId: this.businessParams.actInstId,
        actInstName: this.businessParams.actInstName,
        taskId: this.businessParams.taskId,
        readOpinion: "",
        agentId: this.businessParams.agentId,
        currentOperUserId: this.businessParams.readUserId,
        currentOperUserDeptId: this.businessParams.readUserDeptId
      };
      getUpdataRead(obj).then(res => {
        if (res.data.code == "0") {
          this.messageInfo("success", res.data.message);
        } else {
          this.messageInfo("error", res.data.message);
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    // 离开组件顶部导航清除active
    let navDom = document.querySelectorAll(".el-top-nav-menu3 .nav a");
    for (let dom of navDom) {
      if (dom.hash.slice(1) === this.breadcrumbObj.path) {
        dom.classList.remove("router-link-active");
      }
    }
    next();
  }
};
